import { Component, OnInit, TemplateRef, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../shared/config/app-config';
import { UserService, PatientService, FormSessionCanDeactivate } from '../../shared';
import { User } from '../../shared/models';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import * as _ from 'lodash'
import { ToastrService } from 'ngx-toastr';
import { cloneWithOffset } from 'ngx-bootstrap/chronos/units/offset';
import { DatePipe } from '@angular/common';
import {
  DxDataGridComponent,
  DxDataGridModule,
  DxSelectBoxModule,
  DxCheckBoxModule
} from 'devextreme-angular';
import { SECOND } from 'ngx-bootstrap/chronos/units/constants';
import { TimepickerConfig } from 'ngx-bootstrap/timepicker';
import { Subscription } from 'rxjs';
export function getTimepickerConfig(): TimepickerConfig {
  return Object.assign(new TimepickerConfig(), {
    hourStep: 1,
    minuteStep: 10,
    showMeridian: true,
    readonlyInput: false,
    mousewheel: true,
    showMinutes: true,
    showSeconds: false,
    showSpinners: false
  });
}
@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.css'],
  providers: [{ provide: TimepickerConfig, useFactory: getTimepickerConfig }]
})

export class AppointmentsComponent extends FormSessionCanDeactivate {
  public imageURL: string = environment.cloudeImageURL;
  phoneset: string;
  tooltipnew: any;
  public dateform = environment.dateForm
  currentUser: User;
  schedule: boolean = false;
  schedule1: boolean = false;
  public data: Object;
  modalRef: BsModalRef;
  modaldata: any;
  public today;
  public hstep = 1;
  public mstep = 30;
  public temp_var: boolean = false;
  public appointments: any;
  public patient: any;
  public patname: any;
  public checkDos: any;
  public apiurl: any = environment.api_url;
  public timealert = environment.timelimit;
  public patientAppoinmentList = [];
  dtOptions: any = {};
  public mintimeset = 0;
  public dateformat = environment.dateFormat;
  public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
  //timer array for select appoinment dropdown
  allowMouseWheel = true;
  userSubscription : Subscription;
  public timeArray = [
    {
      value: '07:00 AM',
      name: '07:00 AM',
      check: 7
    },
    {
      value: '07:30 AM',
      name: '07:30 AM',
      check: 7.5
    },
    {
      value: '08:00 AM',
      name: '08:00 AM',
      check: 8
    },
    {
      value: '08:30 AM',
      name: '08:30 AM',
      check: 8.5
    },
    {
      value: '09:00 AM',
      name: '09:00 AM',
      check: 9
    },
    {
      value: '09:30 AM',
      name: '09:30 AM',
      check: 9.5
    },
    {
      value: '10:00 AM',
      name: '10:00 AM',
      check: 10
    },
    {
      value: '10:30 AM',
      name: '10:30 AM',
      check: 10.5
    },
    {
      value: '11:00 AM',
      name: '11:00 AM',
      check: 11
    },
    {
      value: '11:30 AM',
      name: '11:30 AM',
      check: 11.5
    },
    {
      value: '12:00 PM',
      name: '12:00 PM',
      check: 12
    },
    {
      value: '12:30 PM',
      name: '12:30 PM',
      check: 12.5
    },
    {
      value: '01:00 PM',
      name: '01:00 PM',
      check: 13
    },
    {
      value: '01:30 PM',
      name: '01:30 PM',
      check: 13.5
    },
    {
      value: '02:00 PM',
      name: '02:00 PM',
      check: 14
    },
    {
      value: '02:30 PM',
      name: '02:30 PM',
      check: 14.5
    },
    {
      value: '03:00 PM',
      name: '03:00 PM',
      check: 15
    },
    {
      value: '03:30 PM',
      name: '03:30 PM',
      check: 15.5
    },
    {
      value: '04:00 AM',
      name: '04:00 PM',
      check: 16
    },
    {
      value: '04:30 PM',
      name: '04:30 PM',
      check: 16.5
    },
    {
      value: '05:00 PM',
      name: '05:00 PM',
      check: 17
    },
    {
      value: '05:30 PM',
      name: '05:30 PM',
      check: 17.5
    },
    {
      value: '06:00 PM',
      name: '06:00 PM',
      check: 18
    },
    {
      value: '06:30 PM',
      name: '06:30 PM',
      check: 18.5
    },
    {
      value: '07:00 PM',
      name: '07:00 PM',
      check: 19
    }
  ]
  newAttribute: any = {};
  patientlength: any[];
  patlength: number;
  surgerydate: Date;
  minsurgerydate: Date
  scheduledate: boolean = false;
  dischargedate: Date;
  currentdata: Date;
  currentdate: Date = new Date();
  patientSWId: any;
  patientId: any;
  @ViewChild('scrollMe')
  private myScrollContainer: ElementRef;
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  exportTooltip = 'Export All Data';

  getTotalPageCount () {
    return this.userService.translateText('hospital_portal.mytodos.pagination.label');
  }
  filterValue: any;
  selectbox: boolean = false;
  defaultpatlist: any[];
  addnew: boolean = false;
  showbutton: any = [];
  tempapp: any[];
  disableAddNew: boolean = false;
  disableSubmit: boolean = false;
  disableCancel: boolean = false;
  isMeridian: boolean = true;

  // myTime: Date = new Date();
  minTime: Date;
  maxTime: Date;
  setmask: any;
  setMode:any = "active"
  constructor(
    private patientservice: PatientService,
    private userService: UserService,
    private modalService: BsModalService,
    private toast: ToastrService,
    private DatePipe: DatePipe,
    private router: Router,

  ) {

    super();
    this.filterValue = []
    if (localStorage.getItem("appoinmentFilter")) {
      this.filterValue = JSON.parse(atob(localStorage.getItem("appoinmentFilter")));
    }
    this.minTime = new Date();
    this.maxTime = new Date();

    this.minTime.setHours(7);
    this.minTime.setMinutes(0);
    this.maxTime.setHours(19);
    this.maxTime.setMinutes(0);
    this.exportTooltip = this.userService.translateText('hospital_portal.mytodos.export_all_data.tooltip');

  }

  ngOnInit() {




    this.dtOptions = {

      pageLength: 10,
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
      dom: 'Blfrtip',
      buttons: [
        {
          extend: 'excelHtml5',
          text: 'Download Excel',
          className: 'datatablebuttons btn btn-chnag buttons-pdf buttons-html5',
          title: this.getTitle()
        },
        {
          extend: 'pdfHtml5',
          orientation: 'landscape',
          text: 'Download PDF',
          className: 'datatablebuttons btn btn-chnag buttons-pdf buttons-html5',
          title: this.getTitle()
        },

      ]
    };
    this.currentdate.setDate(this.currentdate.getDate());
    ////console.log(this.currentdate)
    this.userSubscription = this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        if (this.currentUser.item) {
          this.setmask = this.currentUser.item.setmask.concat('0')
          if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
            this.dateform = environment.dateForm;
          } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
            this.dateform = 'dd/MM/yyyy'
          }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
        }
      }
    );
    if (this.currentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL;

    this.getAppoinmentsListMaster(this.setMode);

  }
  viewpatsummary(patswfid){
    let tempvar = {patSWFId : patswfid}
    this.userService.setTempVar(tempvar)
    this.router.navigate([`/care/patientsummary`])
  }
  getTitle() {

    return `Appointments List`;
  }
  //get master appoinments list for all patient
  getAppoinmentsListMaster(mode) {
    this.temp_var = false;
    this.patientservice
      .getpatientappointments(this.currentUser.item.userAccountId,mode)
      .subscribe(
        data => {
          this.temp_var = true;
          this.appointments = data;

          this.appointments.forEach(element => {
            if (element.dosStr) {
              element.dos = this.DatePipe.transform(element.dosStr, this.dateform)
            }
            if (element.currentAppntDateStr) {
              element.currentAppntDate = this.DatePipe.transform(element.currentAppntDateStr, this.dateform)
            }
            if (element.appmntTitle.search('Discharge') != -1) {
              element.appmntTitle = 'Discharge'
            }
            if (element.fracture) {
              element.fract = this.userService.translateText('hospital_portal.mytodos.fracture.column')
            }
            if (element.mako == 'Yes') {
              element.mak = this.userService.translateText('hospital_portal.add_patient.robotics.label')
            }
          });
        }
      );
  }


  hospitalList: any;
  getEpisodeAppointmenthospitallist(patientSWId) {
    this.patientservice
      .getEpisodeAppointmenthospitallist(this.currentUser.item.userAccountId, patientSWId)
      .subscribe(
        data => {
          // this.temp_var = true;
          this.hospitalList = data.aaData;
          this.hospitalList.forEach(item=>{item.otherAppmntHspMasterName == null ? item.otherAppmntHspMasterName ="" : item.otherAppmntHspMasterName})
          //console.log("this.hospitalList",this.hospitalList)
        }
      );
  }



  //edit the appoinmet for particular patient
  /**
   * 
   * @param template edit appoinment modal
   * @param emp select patient details
   */
  public deleteapp: any = true
  DatePickerMinDate : Date;
  update(template: TemplateRef<any>, emp: any) {
    let self = this;
    this.modaldata = emp;    
    this.DatePickerMinDate = new Date(this.modaldata.parseDob)
    this.patname = emp.firstName + " " + emp.lastName;
    //console.log(emp.patientSWId, "Pat SWF ID")
    self.getAppoinmentsList(emp.patientSWId)
    //Get Appointment hospital List
    if (this.currentUser.item)
      this.getEpisodeAppointmenthospitallist(emp.patientSWId);
    self.deleteapp = true
    self.patientSWId = emp.patientSWId
    self.patientId = emp.patientFk
    this.modalRef = this.modalService.show(template, { class: 'modal-lg', backdrop: 'static' });
    this.movable()
    this.showapp();
    this.disableSubmit = false

  }
  //get appoinments list by patient stage workflow id
  /**
   * 
   * @param id patient stage workflow id
   */
  tempappmnt: any;
  getAppoinmentsList(id) {
    let self = this;
    self.patientservice.getAppoinmentsListwitSWFid(id)
      .subscribe(
        data => {
          if (self.modaldata.dos) {
            self.checkDos = new Date(self.modaldata.dos)
          }


          data.forEach(element => {
            if (element.appointmentTime) {
              var tst
              var hms = element.appointmentTime;   // your input string
              var a = hms.split(' '); // split it at the space
              // let dateString = '1968-11-16' + element.appointmentTime;
              //element.appointmentTime =new Date(dateString)

              if (a[1] == "PM") {
                tst = a[0].split(':')
                if (Number(tst[0]) != 12)
                  tst[0] = Number(tst[0]) + 12;
                // tst[0] =  Number(tst[0])==24? "00": tst[0]
                a[0] = tst[0] + ':' + tst[1]
              }
              else {
                tst = a[0].split(':')
                // if(Number(tst[0])!=12)
                tst[0] = Number(tst[0]) == 12 ? "00" : tst[0]
                a[0] = tst[0] + ':' + tst[1]
              }

              a = a[0] + ':00'  //+ a[1]
              let appdate = element.appointmentDate.split(' ');
              let dateString = appdate[0] + ' ' + a;
              let datesTimes = new Date(dateString);
              element.appointmentTime = datesTimes


            }

            if (element.hospitalId && element.appointmentDate)
              element.selectHospital = element.hospitalName;
            else if (element.otherAppmntHspMasterId && element.appointmentDate)
              element.selectHospital = element.otherAppmntHspMasterName;
            //  else
            //  element.selectHospital = 

            element.selectOtherHospital = ""
            element.validTime = true;
            element.appointmenttimechange = false;

          });

          self.patientAppoinmentList = _.map(data, self.changeDateFormat)

          self.defaultpatlist = _.map(data, self.changeDateFormat)
          this.patlength = this.patientAppoinmentList.length
          var filterlist = this.patientAppoinmentList.filter(item => (item.appointmentTitle == 'Surgery') && (String(item.appointmentId).length >= 5))
          var filterdischarge = this.patientAppoinmentList.filter(item => (item.appointmentTitle == 'Discharge') && (String(item.appointmentId).length >= 5))
          ////console.log(filterlist)
          for (var item of this.patientAppoinmentList) {
            if (item.appointmentTitle == 'Surgery') {
              if (this.setstage(item.appointmentDate)) {
                item.completedDate = new Date(item.appointmentDate)
              }
            }

            // this.patientAppoinmentList.forEach(it => {
            //   if(!it.appointmentTime){
            //   // it.appointmentTime = new Date();
            //   //  it.appointmentTime.setHours();
            //   //  it.appointmentTime.setMinutes();
            //   }
            // })
            /*  if(item.appointmentTitle == 'Pre-Operative Testing' || item.appointmentTitle == 'Pre-Operative Class' || item.appointmentTitle == 'CT Scan'){
     if(item.appointmentDate){
       item.completedDate = new Date(item.appointmentDate)
     }
             } */
          }
          this.surgerydate = new Date(filterlist[0].appointmentDate)
          this.minsurgerydate = new Date(filterlist[0].appointmentDate)
          this.minsurgerydate.setDate(this.minsurgerydate.getDate() - 1)
          ////console.log(filterdischarge)
          this.dischargedate = new Date(filterdischarge[0].appointmentDate)
          ////console.log(this.surgerydate, this.dischargedate)
          this.tempapp = self.defaultpatlist
          for (var i = 0; i < this.patientAppoinmentList.length; i++) {
            this.patientAppoinmentList[i].appmntModified = false
            this.patientAppoinmentList[i].appmntStatus = "Exist"
          }
          this.deleteapp = true
        }
      )
  }
  setstage(event) {
    if (event) {
      let toDate = new Date();
      if (event.setHours(0, 0, 0, 0) == toDate.setHours(0, 0, 0, 0)) {
        return true
      } else {
        return false
      }

    }
    return false
  }
  clo() {
    this.modalRef.hide();
    this.scheduledate = false;
    this.addnew = false;
    this.disableAddNew = false
    this.getAppoinmentsListMaster(this.setMode)
  }
  // check future appoinments are completed
  /**
   * 
   * @param i index
   */
  checkAppoinment(i) {

    let self = this;
    var booleanArray = [];
    for (let j = i; j < this.patlength; j++) {
      if (self.patientAppoinmentList[j].completedDate) {
        booleanArray.push(true)
      }
    }


    // self.patientAppoinmentList.forEach(it =>{
    //     if(it.completedDate){
    //       booleanArray.push(true)
    //     }
    // })


    if (booleanArray.length) {

      return booleanArray.includes(true)
    }
    else {
      return false;
    }
  }
  checkAppEmpty(i) {

    let self = this;

    if (!self.patientAppoinmentList[i].appointmentDate) {
      return true
    }
    else {
      return false
    }

  }

  //change dateformat for date picker
  /**
   * 
   * @param n appoinments object
   */
  changeDateFormat(n) {
    if (n.appointmentDate) {
      n.appointmentDate = new Date(n.appointmentDate)
    }
    if (n.completedDate) {
      n.completedDate = new Date(n.completedDate);
    }
    return n
  }
  addFieldValue() {
    //this.addnew = true
    this.patientAppoinmentList.push({
      'appointmentTitle': "",
      'appointmentDate': "",
      'appointmentTime': "",
      'otherAppmntHspMasterId': 0,
      "selectHospital": "",


    });
    //this.disableAddNew = true
    this.allstatus()
  }
  //change date format for save
  /**
   * 
   * @param n appoinments array
   */
  changeDateFormatarray(n) {
    let self = this;
    for (let i = 0; i < n.length; i++) {
      if (n[i].appointmentDate) {
        n[i].appointmentDate = self.DatePipe.transform(n[i].appointmentDate, 'yyyy-MM-dd');
      }
      if (n.completedDate) {
        n[i].completedDate = self.DatePipe.transform(n[i].completedDate, 'yyyy-MM-dd');
      }
    }
  }

  deleteEmptyAppoinment() {

    return _.remove(this.patientAppoinmentList, (n: any): any => {
      return (!n.appointmentTitle
        && (n.appointmentMode == "custom" || !n.appointmentMode))
    });
  }


  //save edited appoinmets;
  saveAppoinments() {
    this.changeTimeFormat()
    let self = this;
    self.disableSubmit = true
    let loginHospitalId: any;
    this.deleteEmptyAppoinment()    
    loginHospitalId = this.currentUser ? this.currentUser.item ? this.currentUser.item.userAccountKey : 0 : "";
    self.arrangaData(self.patientAppoinmentList).then(
      data => {
        self.patientservice.saveAppoinments(data, loginHospitalId, self.patientSWId)
          .subscribe(
            data => {
              self.toast.success(this.userService.translateText('hospital_portal.appointments.appointment_updated.success'), '', {
                timeOut: this.timealert
              });
              this.disableAddNew = false;
              this.userService.logAudit('savePatientAppointment', 0).subscribe(data => { })
              self.getAppoinmentsListMaster(this.setMode);
              self.modalRef.hide()
            }
          )
      }, err => {

      }
    )
  }



  changeTimeFormat() {

    this.patientAppoinmentList.forEach(it => {
      if (it.appointmentTime)
        it.appointmentTime = it.appointmentTime.toLocaleTimeString(navigator.language, { hour: '2-digit', minute: '2-digit' });
    })
  }
  //filter time incase appoinment set to today
  /**
   * 
   * @param event selected date
   * @param i index
   */
  allstatus() {

    //var allstatus = this.patientAppoinmentList.filter(item => item.appointmentTitle == '')
    // let index = _.findIndex(this.patientAppoinmentList, (o: any): any => {
    //   return o.appointmentTitle == ''
    // })

    let index1 = this.patientAppoinmentList.filter(it => it.appointmentTitle && !it.appointmentDate
      && (it.appointmentMode == "custom" || !it.appointmentMode))

    // if (index != -1 || index1.length!=0) {
    if (index1.length != 0) {
      //this.disableAddNew = true;
      return true
    }
    let index = this.patientAppoinmentList.filter(it => !it.appointmentTitle)
    if (index.length != 0) {
      //this.disableAddNew = true;
      return true
    }

    //this.disableAddNew = false;
  }
  checkTime(event, i) {
    this.allstatus()
    let self = this;
    if (event) {
      if (self.patientAppoinmentList[i].appointmentDate) {
        let today = new Date();
        let timeNow = new Date().getHours();
        let min = new Date().getMinutes();
        let appointmentDate = new Date(self.patientAppoinmentList[i].appointmentDate)
        if (today.setHours(0, 0, 0, 0) == appointmentDate.setHours(0, 0, 0, 0)) {
          if (min > 30) {
            self.mintimeset = timeNow + 1;
          } else {
            self.mintimeset = timeNow + 0.5;
          }
        } else {
          self.mintimeset = 0;
        }
      }
    }

  }
  changeTime(event, i) {

    this.allstatus()
    ////console.log(event,i)

    var result = this.find_duplicate_in_array(this.patientAppoinmentList)
    if (result.length > 0) {
      if (i >= this.patlength) {
        let applist = []
        this.patientAppoinmentList.forEach((element,index) => {
          if(index != i)
            applist.push(element)
        }); 
        let index = _.findIndex(applist, (o: any): any => {
          return (o.appointmentTitle == event.appointmentTitle && o.appointmentDate.setHours(0, 0, 0, 0) == event.appointmentDate.setHours(0, 0, 0, 0) && o.appointmentTime == event.appointmentTime)
        })


        if (index != -1) {
          ////console.log(i,this.patlength)
          if (i >= this.patlength) {
            this.scheduledate = true
            //this.disableAddNew = true

            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })
          }
          else if (i < this.patlength) {
            this.scheduledate = true
            //this.disableAddNew = true
            this.patientAppoinmentList[i].appointmentTitle = ''
            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })
          }
        }
        else {
          this.scheduledate = false
          this.patientAppoinmentList[i].appmntModified = true
          let self = this;
          if (i < this.patlength) {
            self.getAppoinmentsListwitSWFid(i)
          } else {
            this.patientAppoinmentList[i].appmntStatus = 'New'
          }
        }
      }
      else if (i < this.patlength) {
        // let applist = this.patientAppoinmentList.slice(0, -1);
        const filteredItems = this.patientAppoinmentList.slice(0, i).concat(this.patientAppoinmentList.slice(i + 1, this.patientAppoinmentList.length))
        let index = _.findIndex(filteredItems, (o: any): any => {
          return (o.appointmentTitle == event.appointmentTitle && o.appointmentDate.setHours(0, 0, 0, 0) == event.appointmentDate.setHours(0, 0, 0, 0) && o.appointmentTime == event.appointmentTime)
        })


        if (index != -1) {
          ////console.log(i,this.patlength)
          if (i >= this.patlength) {
            this.scheduledate = true
            //this.disableAddNew = true
            this.patientAppoinmentList[i].appointmentTitle = ''
            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })
          }
          else if (i < this.patlength) {
            this.scheduledate = true
            //this.disableAddNew = true
            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })
          }
        }
        else {
          this.scheduledate = false
          this.patientAppoinmentList[i].appmntModified = true
          let self = this;
          if (i < this.patlength) {
            self.getAppoinmentsListwitSWFid(i)
          } else {
            this.patientAppoinmentList[i].appmntStatus = 'New'
          }

        }
      }
    }

  }
  getAppoinmentsListwitSWFid(i) {
    let self = this;
    self.patientservice.getAppoinmentsListwitSWFid(self.patientSWId)
      .subscribe(
        data => {
          if (self.modaldata.dos) {
            self.checkDos = new Date(self.modaldata.dos)
          }
          self.tempappmnt = data;
          if (this.tempappmnt[i].appointmentTitle && this.tempappmnt[i].appointmentDate) {
            this.patientAppoinmentList[i].appmntStatus = 'Modify'
          } else {
            this.patientAppoinmentList[i].appmntStatus = 'New'
          }
        })
  }
  find_duplicate_in_array(arra1) {
    var object = {};
    var result = [];

    arra1.forEach(function (item) {
      if (!object[item.appointmentTitle]) {
        object[item.appointmentTitle] = 0;
      }
      object[item.appointmentTitle] += 1;
    })

    for (var prop in object) {
      if (object[prop] >= 2) {
        result.push(prop);
      }
    }

    return result;

  }
  checkDate(event, i) {
    this.allstatus()
    ////console.log(event,i)
    
    // this.disableSubmit = false
    if(event.appointmentDate < new Date(this.modaldata.parseDob) ){      
            //this.disableAddNew = true                 
      let self = this      
      this.patientAppoinmentList[i].appointmentDate = null
      this.patientAppoinmentList[i].appointmentTime = ''
      this.patientAppoinmentList[i].appmntModified = false
      self.toast.error(this.userService.translateText('hospital_portal.appointments.appointment_cannot_be_dob.error'), '', {
        timeOut: this.timealert
      })
      
      // this.disableSubmit = true
      return 
    }
      

    var result = this.find_duplicate_in_array(this.patientAppoinmentList)
    if (result.length > 0) {

      if (i >= this.patlength) {
        let applist = this.patientAppoinmentList.slice(0, -1);
        let index = _.findIndex(applist, (o: any): any => {
          return (o.appointmentTitle == event.appointmentTitle && o.appointmentDate.setHours(0, 0, 0, 0) == event.appointmentDate.setHours(0, 0, 0, 0) && o.appointmentTime == event.appointmentTime && event.appointmentTitle != "")
        })


        if (index != -1 && index != i) {
          ////console.log(i,this.patlength)
          if (i >= this.patlength) {
            this.scheduledate = true
            //this.disableAddNew = true

            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })
          }
          else if (i < this.patlength) {
            this.scheduledate = true
            //this.disableAddNew = true
            this.patientAppoinmentList[i].appointmentTitle = ''
            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })
          }
        }
        else {
          this.scheduledate = false
          this.patientAppoinmentList[i].appmntModified = true
          let self = this;
          if (i < this.patlength) {
            self.getAppoinmentsListwitSWFid(i)
          } else {
            this.patientAppoinmentList[i].appmntStatus = 'New'
          }
        }
      }
      else if (i < this.patlength) {
        //  let applist = this.patientAppoinmentList.slice(i, -i);

        const filteredItems = this.patientAppoinmentList.slice(0, i).concat(this.patientAppoinmentList.slice(i + 1, this.patientAppoinmentList.length))
        let index = _.findIndex(filteredItems, (o: any): any => {
          return (o.appointmentTitle == event.appointmentTitle && o.appointmentDate.setHours(0, 0, 0, 0) == event.appointmentDate.setHours(0, 0, 0, 0) && o.appointmentTime == event.appointmentTime)
        })


        if (index != -1 && index != i) {
          ////console.log(i,this.patlength)
          if (i >= this.patlength) {
            this.scheduledate = true
            //this.disableAddNew = true
            this.patientAppoinmentList[i].appointmentTitle = ''
            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })
          }
          else if (i < this.patlength) {
            this.scheduledate = true
            ///this.disableAddNew = true
            this.patientAppoinmentList[i].appointmentDate = null
            this.patientAppoinmentList[i].appointmentTime = ''
            this.patientAppoinmentList[i].appmntModified = false
            this.toast.error(this.userService.translateText('patient_portal.display_messages.appointment_already_exist'), '', {
              timeOut: this.timealert
            })

          }
        }
        else {
          this.scheduledate = false
          this.patientAppoinmentList[i].appmntModified = true
          let self = this;
          if (i < this.patlength) {
            self.getAppoinmentsListwitSWFid(i)
          } else {
            this.patientAppoinmentList[i].appmntStatus = 'New'
          }
        }
      }
    }
    this.patientAppoinmentList[i].appmntModified = true

    if (i < this.patlength) {
      let self = this;
      self.getAppoinmentsListwitSWFid(i)
    } else {
      this.patientAppoinmentList[i].appmntStatus = 'New'
    }


    //////console.log(this.patientAppoinmentList[2].appointmentDate)
    let self = this;
    let date

    if (event.appointmentDate == '' || event.appointmentDate == null || event.appointmentDate == 'Invalid Date') {



      this.patientAppoinmentList[i].appointmentDate = null

      ////console.log(this.scheduledate)
      self.toast.error(this.userService.translateText('hospital_portal.appointments.please_enter_mmddyy_format.error'), '', {
        timeOut: this.timealert
      })
      ////console.log(this.scheduledate,"status")
    } else {
      //this.scheduledate = false
    }


    if (event.appointmentDate && (this.patientAppoinmentList[i].appointmentTitle == 'Pre-Operative Testing' || this.patientAppoinmentList[i].appointmentTitle == 'Pre-Operative Class' || this.patientAppoinmentList[i].appointmentTitle == 'CT scan')) {

      if (self.surgerydate) {

        let todayplus = new Date();
        todayplus.setDate(todayplus.getDate() - 1);
        let eventdate = new Date(event.appointmentDate.setHours(0, 0, 0, 0))
        if (eventdate >= self.surgerydate) {

          this.patientAppoinmentList[i].appointmentDate = null

          ////console.log( this.patientAppoinmentList[0].appointmentDate)

          this.scheduledate = true
          self.toast.error(this.userService.translateText('patient_portal.display_messages.please_select_date.error')+`  ${self.DatePipe.transform(self.surgerydate, this.dateform)}`, '', {
            timeOut: this.timealert
          })


        }
        /*   else if (eventdate < todaydate) {
            
            this.patientAppoinmentList[i].appointmentDate = null
         
            ////console.log( this.patientAppoinmentList[0].appointmentDate)
            
           this.scheduledate = true
            self.toast.error(`Please Select the date after  ${date = self.DatePipe.transform(todayplus, this.dateform)}`, '', {
              timeOut: this.timealert
            })
            
          
          } */
        else {
          this.scheduledate = false
        }
      }
    }
    /*  else if (event && i == 1) {
       if (self.surgerydate) {
         if (event > self.surgerydate) {
         
         this.scheduledate = true
           self.toast.error(`Please Select the date before ${date = self.DatePipe.transform(self.surgerydate, this.dateform)}`, '', {
             timeOut: this.timealert
           })
         }
         else{
           this.scheduledate = false
         }
       }
     } */
    /*  else if (event.appointmentDate && i >= this.patlength) {
       let today = new Date();
       let todayplus = new Date();
       todayplus.setDate(todayplus.getDate()-1); 
       ////console.log(today)
       ////console.log(todayplus)
       if (self.surgerydate && self.dischargedate) {
         let todaydate = new Date(today.setHours(0,0,0,0))
         let eventdate = new Date(event.appointmentDate.setHours(0,0,0,0))
         if(self.dischargedate < today){
           
         if(eventdate < todaydate){
          self.patientAppoinmentList[i].appointmentDate = null
          this.scheduledate = true
           self.toast.error(`Please Select the date after  ${date = self.DatePipe.transform(todayplus, this.dateform)}`, '', {
             timeOut: this.timealert
           })
            
         }
         
         else if(eventdate > todaydate){
           this.scheduledate = false
         }
       }
       else if(self.dischargedate > today){
        
         if(eventdate < todaydate){
           this.scheduledate = true
           self.patientAppoinmentList[i].appointmentDate = null
           self.toast.error(`Please Select the date after  ${date = self.DatePipe.transform(todayplus, this.dateform)}`, '', {
             timeOut: this.timealert
           })
         }
         else if(eventdate > todaydate){
           this.scheduledate = false
         }
        
       }
     }
     } */
    /*  else if (event.appointmentDate && i < this.patlength) {
       let today = new Date();
       let todayplus = new Date();
       todayplus.setDate(todayplus.getDate()-1); 
       ////console.log(today)
       ////console.log(self.dischargedate)
       if (self.surgerydate && self.dischargedate) {
         let todaydate = new Date(today.setHours(0,0,0,0))
         let eventdate = new Date(event.appointmentDate.setHours(0,0,0,0))
         if(self.dischargedate < today){
         
         if(eventdate < todaydate){
          self.patientAppoinmentList[i].appointmentDate = null
          this.scheduledate = true
           self.toast.error(`Please Select the date after  ${date = self.DatePipe.transform(todayplus, this.dateform)}`, '', {
             timeOut: this.timealert
           })
            
         }
         else if(eventdate > todaydate){
           this.scheduledate = false
         }
       }
       else if(self.dischargedate > today){
         let todaydate = new Date(today.setHours(0,0,0,0))
         let eventdate = new Date(event.appointmentDate.setHours(0,0,0,0))
         if(eventdate < todaydate){
           this.scheduledate = true
           self.patientAppoinmentList[i].appointmentDate = null
           self.toast.error(`Please Select the date after  ${date = self.DatePipe.transform(todayplus, this.dateform)}`, '', {
             timeOut: this.timealert
           })
         }
         else if(eventdate > todaydate){
           this.scheduledate = false
         }
        
       }
     }
     } */
  }
  //rearrange the date before save it
  /**
   * 
   * @param dataArray appoinments array
   */
  arrangaData(dataArray) {
    ////console.log(dataArray)
    let self = this;
    let data = [];
    //  let appoinmets$ =
    let promise = new Promise((resolve, reject) => {
      for (let i = 0; i < dataArray.length; i++) {

        let sampleObj = Object.assign({}, dataArray[i])
        if (sampleObj.hospitalId == -2) {
          sampleObj.hospitalId = "";
        }
        if (sampleObj.appointmentDate) {
          sampleObj.appoinmentWithId = this.patientAppoinmentList[i].patientSurgeonId;
          if (!sampleObj.appoinmentWithId && i < this.patlength) {
            self.toast.error(this.userService.translateText('hospital_portal.appointments.select_surgen_name.error') + sampleObj.appointmentTitle, '', {
              timeOut: this.timealert
            })
            reject("Error");
          }
        }
        ////console.log(i,"i")

        sampleObj.superClientId = window.localStorage['superClientId'] ? window.localStorage['superClientId'] : this.currentUser.item.userAccountId
        if (!sampleObj.appoinmentWithId && i >= this.patlength) {
          sampleObj.appoinmentWithId = '';
          sampleObj.patientSurgeonId = '';
          sampleObj.patientSurgeonName = '';
          sampleObj.appoinmentWith = '';
          sampleObj.appointmentId = '';
          sampleObj.patientId = self.patientId;
          sampleObj.patientSwfId = self.patientSWId;
          sampleObj.appointmentMode = "custom";
          ////console.log(self.patientId,self.patientSWId)
        }
        if (!sampleObj.appointmentDate) {
          sampleObj.appointmentDate = null;
        }
        if (!sampleObj.appointmentTime) {
          sampleObj.appointmentTime = null
        }
        if (sampleObj.appointmentDate) {
          sampleObj.appointmentDate = self.DatePipe.transform(sampleObj.appointmentDate, 'yyyy-MM-dd');
        }
        if (sampleObj.completedDate) {
          sampleObj.completedDate = self.DatePipe.transform(sampleObj.completedDate, 'yyyy-MM-dd');
        }
        else if (!sampleObj.completedDate) {
          sampleObj.completedDate = null;
        }

        if (!sampleObj.selectHospital) {
          sampleObj.hospitalId = "";
          sampleObj.hospitalName = "";
        }
        ////console.log(sampleObj,"sampleObj")
        data.push(sampleObj)
        ////console.log(data,"data")
      }
      resolve(data)
    })
    return promise
  }
  //cancel a single appoinment
  /**
   * 
   * @param index index
   * @param data appoinment data
   */
  cancelAppointment(index, data) {
    this.deleteapp = false
    ////console.log(index)
    ////console.log(data)
    let self = this;
    if (data.appointmentDate && data.appoinmentWithId) {
      self.patientservice.cancelAppoinments(data).subscribe(
        res => {
          // var str = new String(data.appointmentId);
          // if (index && str.length >= 5) {
          //   self.patientAppoinmentList[index].appointmentTime = 0;
          //   self.patientAppoinmentList[index].appointmentTime = '';
          //   self.patientAppoinmentList[index].appointmentDate = '';
          //   self.patientAppoinmentList[index].appoinmentWithId = '';

          // }else{
          //   this.patientAppoinmentList.splice(index, 1);
          //   this.patlength = this.patientAppoinmentList.length
          // }
          this.getAppoinmentsList(self.patientSWId)
          self.toast.success(this.userService.translateText('hospital_portal.appointments.appointment_was_cancelled.error'), '', {
            timeOut: this.timealert
          });
          this.userService.logAudit('cancelPatientAppointment', 0).subscribe(data => { })
        }
      )
    }
    else if (data.appointmentDate && !data.appoinmentWithId) {
      self.patientAppoinmentList[index].appointmentTime = void 0;
      self.patientAppoinmentList[index].appointmentDate = '';
      self.patientAppoinmentList[index].selectHospital = '';
      this.deleteapp = true
    }
    else {
      self.toast.error(this.userService.translateText('hospital_portal.appointments.appointment_cannot_be_empty.error'), '', {
        timeOut: this.timealert
      })
      this.deleteapp = true
    }
    /*else  if(data.appointmentDate == '' || data.appoinmentWithId == '' || data.appointmentTime == ''){
      this.patientAppoinmentList.splice(index, 1);
    }*/
  }
  cancelAppointmentcustom(index, data) {
    ////console.log(index)
    this.patientAppoinmentList.splice(index, 1);
    this.addnew = false
    this.disableAddNew = false
  }
  checkMinDate(index, ...arg) {
    let date = arg;
    let temArray = []
    if (index == 2) {
      if (date[0]) {
        return date[0]
      }
    }
    let todateTime = new Date().getTime();
    for (let i = 0; i < date.length; i++) {
      if (date[i]) {
        let temtime = new Date(date[i]).getTime()
        if (temtime > todateTime) {
          return new Date(temtime)
        }
      }

    }
    return new Date();
  }
  checkMaxDate(...arg) {

  }


  schedulech(id) {
    if (id == '' || id == null || id == 'Invalid Date') {
      this.schedule = true
    } else {
      this.schedule = false
    }
  }

  schedulechs(id) {
    if (id == '' || id == null || id == 'Invalid Date') {
      this.schedule1 = true

    } else {
      this.schedule1 = false
    }
  }


  dateValueChange(event) {
    if (event.keyCode != 8) {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }

  }

  //Maintain filter data
  FilterVal() {
    this.filterValue = this.dataGrid.filterValue;
    localStorage.setItem("appoinmentFilter", btoa(JSON.stringify(this.filterValue)));
    // alert(JSON.stringify(this.filterValue));

  }

  //Clear  Filter data
  clearFilter(event) {
    this.dataGrid.instance.clearFilter();
  }
  showapp() {

    this.userService
      .showappointment(this.currentUser.item.userAccountKey)
      .subscribe(
        data => {
          this.showbutton = data[0].isCustomAppmntConfigured
          ////console.log( this.showbutton)
        })
  }

  newfun(e) {
    this.tooltipnew = e;
    this.phoneset = e.teleCode + ' - ' + e.phone
    if (this.tooltipnew.imagePath.search("default_") != -1)
      this.tooltipnew.deaultimg = true
    else
      this.tooltipnew.deaultimg = false
  }

  getdate(date) {
    if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
      return this.DatePipe.transform(date, environment.dateForm);
    } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
      return this.DatePipe.transform(date, 'dd/MM/yyyy');
    }
  }
  getdatetime(date) {
    if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
      return this.DatePipe.transform(date, 'MM/dd/yyyy hh:mm a');
    } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
      return this.DatePipe.transform(date, 'dd/MM/yyyy hh:mm a');
    }
  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }



  // seperatetime: any;

  // changaeTime(appointmentTime){

  //   alert(appointmentTime)



  //   this.seperatetime =  appointmentTime.toLocaleTimeString();
  //    alert(this.seperatetime)
  // }
  validTime: boolean = true;
  isValid(event: boolean, item, index): void {
    item.validTime = event;
    if (!item.validTime &&!item.appointmentTime && item.appointmentDate && item.appointmenttimechange) {
      item.validTime = false      
        //item.appointmentTime = void 0;
        setTimeout(()=>{
          item.validTime = false;      
        },10)  
        


      this.toast.error(this.userService.translateText('hospital_portal.appointments.please_choose_valid_time.error'), '', {
        timeOut: this.timealert
      });

    }
    else {      
        //item.appointmentTime = void 0;
        setTimeout(()=>{
          item.validTime = true;      
        },10)  
        
    }
    // if(item.appointmentDate && item.selectHospital && !event){
    //   setTimeout(() => {
    //     item.appointmentTime = void 0;
    //   //  this.validTime
    //   }, 10);
    // }
    item.appointmenttimechange = true;
    this.validTmecheck(item)
  }

  validTmecheck(app) {
    let index = _.findIndex(this.patientAppoinmentList, (o: any): any => {
      return !o.validTime
    })

    if (index == -1) {
      this.validTime = true

    }
    else {
      this.validTime = false
    }

  }

  appointTimeChange(event, item) {
    let checkTime, checkmin: any;
    //console.log(event, "Appointmentchange")
    if (event) {
      checkTime = event.getHours();
      checkmin = event.getHours();
      if (checkTime < 7 || checkTime > 19 || (checkTime == 19 && checkmin > 0)) {


        setTimeout(() => {
          item.appointmentTime = void 0;
        }, 10);

        this.toast.error(this.userService.translateText('hospital_portal.appointments.please_choose_appointment_time.error'), '', {
          timeOut: this.timealert
        });
        // this.patientAppoinmentList[i].appointmentTime.setMinutes(null);
        // this.patientAppoinmentList[i].appointmentTime.setSeconds(null);
        //  try{
        //  item.appointmentTime.getDate(new Date())
        //}
        // catch(e){

        // }
        // item.setMinutes(null);
        // item.setSeconds(null);

      }
    }
  }

  hospitalId: any = "";
  changeHospi(appoinmentDetails, event) {
    //console.log(appoinmentDetails,"Appointment List")

    //console.log(event,"Event")

    if (event && event != -2) {
      let hospiList = this.hospitalList.filter(it =>
        it.name.toLowerCase() == event.toLowerCase());
      let mapList = this.hospitalList.filter(it =>
        it.otherAppmntHspMasterName.toLowerCase() == event.toLowerCase());

      //console.log(hospiList, "hospiList")
      setTimeout(() => {
        if (hospiList.length >= 1) {
          appoinmentDetails.hospitalId = hospiList[0].hospitalId;
          // appoinmentDetails.hospitalName = hospiList[0].name;
          appoinmentDetails.otherAppmntHspMasterId = "";
          appoinmentDetails.otherAppmntHspMasterName = "";
          appoinmentDetails.selectHospital = hospiList[0].name;
        }
        else if (mapList.length >= 1) {
          appoinmentDetails.hospitalId = "";
          appoinmentDetails.hospitalName = "";
          appoinmentDetails.otherAppmntHspMasterId = mapList[0].otherAppmntHspMasterId;
          // appoinmentDetails.otherAppmntHspMasterName = mapList[0].otherAppmntHspMasterName;
          appoinmentDetails.selectHospital = mapList[0].otherAppmntHspMasterName;
        }
        else {
          appoinmentDetails.hospitalName = "";
          appoinmentDetails.hospitalId = "";
          appoinmentDetails.otherAppmntHspMasterId = "";
          appoinmentDetails.otherAppmntHspMasterName = event
        }
      }, 10)

    }

    // if(event==-2){
    //   setTimeout(()=>{
    //      appoinmentDetails.hospitalName = "";  
    //       appoinmentDetails.otherAppmntHspMasterId = "";
    //      appoinmentDetails.otherAppmntHspMasterName = "";
    //      appoinmentDetails.hospitalId = event;
    //     // appoinmentDetails.otherAppmntHspMasterName = element.selectOtherHospital
    //   },10)
    // }


  }

  exportToExcel(event) {
    event.fileName = this.getTitle();
    this.dataGrid.instance.exportToExcel(false);
  }

  checkIfOtherAppmntNameAlreadyExists(app) {
    this.patientservice.checkIfOtherAppmntNameAlreadyExists(this.currentUser.item.userAccountKey, app.selectOtherHospital)
      .subscribe(data => {

        if (data.status == "true") {
          app.selectOtherHospital = "";
          app.otherAppmntHspMasterName = app.selectOtherHospital
          this.toast.error(this.userService.translateText('hospital_portal.appointments.appointment_hospital_already_exists.error'), '', {
            timeOut: this.timealert
          })
        }
        else {
          app.otherAppmntHspMasterName = app.selectOtherHospital
        }
      })
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }
}


